import api from './api';

export const apbdService = {
    // PUBLIC
    getPublicApbd: async () => {
        try {
            const response = await api.get('/apbd');
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data APBD' };
        }
    },

    getLatestApbd: async () => {
        try {
            const response = await api.get('/apbd/latest');
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data APBD' };
        }
    },

    requestDownloadToken: async (id, mode = 'download') => {
        const response = await api.post(`/apbd/${id}/download-token`, { mode });
        return response.data;
    },

    // ADMIN
    getApbdList: async (params = {}) => {
        try {
            const response = await api.get('/apbd', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    createApbd: async (formData) => {
        try {
            const response = await api.post('/apbd', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal membuat data' };
        }
    },

    updateApbd: async (id, formData) => {
        try {
            const response = await api.put(`/apbd/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal mengupdate' };
        }
    },

    deleteApbd: async (id) => {
        try {
            const response = await api.delete(`/apbd/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },
};